<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <!-- Form -->
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>
        <v-card-title>
          <span class="headline">{{formTitle}}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- <v-flex xs12 sm6 md3 class="pr-4">
                <v-select
                  label="Project Name"
                  item-text="project_name"
                  item-value="id"
                  v-model="formSchema.operation_id"
                  :items="projectList"
                  :rules="[v => !!v || 'Field is required']"
                ></v-select>
              </v-flex> -->
              <v-flex xs12 sm6 md3 class="pr-4">
                <v-select
                  label="Transaction Type"
                  item-text="name"
                  item-value="name"
                  v-model="formSchema.voucher_type"
                  :items="voucherTypeList"
                  :rules="[v => !!v || 'Field is required']"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pr-4">
                <v-select
                  label="Currency Code"
                  item-text="name"
                  item-value="name"
                  v-model="formSchema.currency_code"
                  :items="currencyCode"
                  @change="setColumn(formSchema.currency_code)"
                  :rules="[v => !!v || 'Field is required']"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pr-4">
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'voucher_date', fieldValue:formSchema.voucher_date, label:'Transaction Date', required:1}"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm3 md3 class="pr-4">
                <v-text-field
                  label="USD Rate"
                  v-model="formSchema.usd_rate"
                  :rules="[v => !!v || 'Field is required']"
                  type="number"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md6 sm6>
                <v-textarea solo name="input-7-4" label="Narration" v-model="formSchema.narration">></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <!-- /Form -->

      <v-card class="mb-3 mt-3" color="lighten-1">
        <v-card-title>
          <span class="headline">Transaction Details</span>
          <v-btn class="float-right" color="success" @click.native="addDetails" :disabled="isDisableAdd">
            <v-icon>save</v-icon>Add
          </v-btn>
        </v-card-title>
        <div id="auto">
        <table id="customers">
          <tr>
            <th>Source Of Fund</th>
            <th>Economic/Account Name</th>
            <th>Code/Number</th>
            <th>Debit</th>
            <th>Credit</th>
            <th v-if="isBdtCol">BDT Debit</th>
            <th v-if="isBdtCol">BDT Credit</th>
            <th v-if="isUsdCol">USD Debit</th>
            <th v-if="isUsdCol">USD Credit</th>
            <th>Credit ID</th>
            <th>Supplier</th>
            <th>Package</th>
            <th>Action</th>
          </tr>
          <tr v-for="(details,index) in formSchema.details" :key="index">
            <td>
              <v-flex xs12 class="pr-2">
                <v-select
                  item-text="name"
                  item-value="name"
                  v-model="details.fund_source"
                  :items="fundSource"
                  clearable
                ></v-select>
              </v-flex>
            </td>

            <td>
              <v-flex xs12 class="pr-2">
                <v-autocomplete            
                  :items="economicList"
                  item-text = "eco_account_name"
                  item-value="id"
                  :rules="[v => !!v || 'Field is required']"
                  clearable
                  single-line hide-details         
                  v-model="details.eco_head_id"
                  @change="setName(index)"
                ></v-autocomplete>

              </v-flex>
            </td>
            <td>
              <v-flex xs12 class="pr-2">
                <v-text-field v-model="details.eco_code" readonly></v-text-field>
              </v-flex>
            </td>
            <td>
              <v-flex xs12 class="pr-2 anim">
                <v-text-field
                  :label="`Hint:(${details.hintAmount})`"
                  v-model="details.transaction_debit"
                  :rules="[rules.isRequire(details.transaction_debit, details.transaction_credit,details.hintAmount)]"
                  type="number"
                  @input="setTRC($event, index)"
                  class="numFont"
                ></v-text-field>
              </v-flex>
            </td>
            <td>
              <v-flex xs12 class="pr-2 anim">
                <v-text-field
                  :label="`Hint:(${details.hintAmount})`"
                  v-model="details.transaction_credit"
                  :rules="[rules.isRequireTRC(details.transaction_credit, details.transaction_debit,details.hintAmount)]"
                  type="number"
                  @input="setTRD($event, index)"
                  class="numFont"
                ></v-text-field>
              </v-flex>
            </td>
            <td v-if="isBdtCol">
              <v-flex xs12 class="pr-2 anim" >
                <v-text-field
                  v-model="details.bdt_debit"
                  class="numFont"
                  type="number"
                ></v-text-field>
              </v-flex>
            </td>
            <td v-if="isBdtCol">
              <v-flex xs12 class="pr-2 anim" >
                <v-text-field
                  v-model="details.bdt_credit"
                  class="numFont"
                  type="number"
                ></v-text-field>
              </v-flex>
            </td>
             <td v-if="isUsdCol">
              <v-flex xs12 class="pr-2 anim" >
                <v-text-field
                  v-model="details.usd_debit"
                  class="numFont"
                  type="number"
                ></v-text-field>
              </v-flex>
            </td>
            <td  v-if="isUsdCol">
              <v-flex xs12 class="pr-2 anim">
                <v-text-field
                  v-model="details.usd_credit"
                  class="numFont"
                  type="number"
                ></v-text-field>
              </v-flex>
            </td>
            
            <td>
              <v-flex xs12 class="pr-2">
                <v-select
                  item-text="credit_name"
                  item-value="id"
                  v-model="details.credit_id"
                  :items="creditId"
                  clearable
                ></v-select>
              </v-flex>
            </td>
            <td>
              <v-flex xs12 class="pr-2">
                <v-select
                  item-text="name"
                  item-value="id"
                  v-model="details.client_id"
                  :items="supplierList"
                  clearable
                ></v-select>
              </v-flex>
            </td>
             <td>
              <v-flex xs12 class="pr-2">
                <v-select
                  item-text="package_no"
                  item-value="id"
                  v-model="details.package_id"
                  :items="packageList"
                  clearable
                ></v-select>
              </v-flex>
            </td>
            <td>
              <!-- <v-btn icon class="mx-0" @click="details(val.id)">
              <v-icon color="teal">remove_red_eye</v-icon>
              </v-btn>-->
              <!-- <v-btn icon class="mx-0" @click="editItem(index, val)">
              <v-icon color="teal">edit</v-icon>
              </v-btn>-->
              <v-btn icon class="mx-0" @click="deleteDetails(index)" v-if="typeof details.id == 'undefined'">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </tr>
          <tr>
            <td colspan="9">
              <v-flex xs12 sm3 md3>
                <v-checkbox v-model="formSchema.is_post" label="Post" :value="isActiveVal" :disabled="!isPosting" ></v-checkbox>
              </v-flex>
            </td>  
          </tr>
        </table>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!isSubmit">
            <v-icon>save</v-icon>
            {{ buttonTitle }}
            <v-progress-circular 
              v-if="Loader" 
              :size="30" 
              :width="10" 
              color="teal" 
              indeterminate 
              style="margin-left:20px;">
            </v-progress-circular>
          </v-btn>
          <v-btn color="error" @click.native="backtolist">
            <v-icon>refresh</v-icon>
            Go To List
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";
import Axios from "axios";

export default {
  components: { DatePicker },

  data: () => ({
    Loader: false,
    isSubmit:false,
    isPosting:false,
    isDisableAdd:false,
    sub_menu: sessionStorage.getItem('sm_id'),
    valid: true,
    isActiveVal: 1,
    parameterTypes: [],
    projectList: [],
    supplierList: [],
    packageList: [],
    isBdtCol:false,
    isUsdCol:false,
    idaAmount:0,
    gobAmount:0,
    voucherTypeList: [{ name: "Payment" }],
    creditId:[],
    economicList: [],
    fundSource: [{ name: "IDA" }, { name: "GoB" }],
    currencyCode: [{ name: "BDT" }, { name: "USD" }],
    formSchema: {
      id: 0,
      operation_id: "",
      voucher_type: "",
      currency_code: "",
      usd_rate: "",
      voucher_date: "",
      narration: "",
      is_post: "",
      module_type:"",
      details: [
        {
          eco_head_id: "",
          eco_code: "",
          transaction_debit: "",
          transaction_credit: "",
          bdt_debit: "",
          bdt_credit: "",
          usd_debit: "",
          usd_credit: "",
          fund_source: "",
          client_id:"",
          package_id:"",
          credit_id:"",
          hintAmount:0
        }
      ]
    },
    rules: { 
      
      isRequire: (v, trc,hint) => { 
        if(v > 0 || trc.length > 0)
        {
          if(v <= parseFloat(hint)){
            return true
          }else{
            return ("Amount Limit " + hint);
          }
          
        }        
        else
        {          
          return ("Must be valid");
        }
    },
     isRequireTRC: (v, trc,hint) => {
  
      if(v > 0 || trc.length > 0)
        {
          if(v <= parseFloat(hint)){
            return true
          }else{
            return ("Amount Limit " + hint);
          }
        }
        else
        {
          return ("Must be valid");
        }
      },
    },
   
    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },
      { text: "Type Name", align: "left", sortable: true, value: "type_name" },
      {
        text: "Short Name",
        align: "left",
        sortable: true,
        value: "short_name"
      },
      { text: "Action", value: "" }
    ],
    /*------------- /Datatable ---------------*/

    delete_id: "",
    row_index: "",
    dialog2: false,

    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    }
  }),

  /*------------Datatable------------*/
  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    },
    'formSchema.is_post'(newVal){
      if(newVal == 1){
        this.isDisableAdd = true
      }else{
        this.isDisableAdd = false
      }
    }
  },

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? "Update Transaction Entry" : "Transaction Entry";
    },
    buttonTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },
    resetButton() {
      return this.formSchema.id > 0 ? "Back" : "Reset";
    },

    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    },
    
  },
  /*------------/Datatable------------*/

  // Page Load Before Called Mathodes =========================================
  created() {
    let root = this;
    // Form Edit section from Here ------------------------
    let voucher_id = this.$store.getters.GET_VOUCHER_ENTRY_DATA;
    // Get Voucher Data
    if(voucher_id != ''){
      commonService
      .getAllDataById(voucher_id, "get_voucher_master_data")
      .then(res => {
        // Item Amount Validation
        var date = res.data.voucher_date;
        res.data.details.forEach((value, index) => {
            var eco_id = value.eco_head_id;
            var source = value.fund_source;
            var currency = value.currency_code;
            var rate = value.usd_rate;
            let arrData = {date:date,source:source,id:eco_id,currency:currency,rate:rate};
            commonService.dataByMulParameters(arrData, "get_amount_by_eco").then(res1 => {
                this.formSchema.details[index].hintAmount = parseFloat(res1.amount);
            });
        });

        this.formSchema = res.data;
        //this.formSchema.client_id = res.data.details.client_id;
        this.formSchema.voucher_date = this.changeFormateDMY(
          res.data.voucher_date
        );
        this.formSchema.transaction_debit = Math.round(res.data.transaction_debit)
        // Set Details Cilumn as Currancy
        if(res.data.currency_code == 'USD'){
          this.isBdtCol = true;
          this.isUsdCol = false;
        }else{
          this.isBdtCol = false;
          this.isUsdCol = true;
        }
        this.$store.commit("UNSET_VOUCHER_ENTRY_DATA");
        this.checkDrCr();
      });
    }
    

    // Get Project data
    commonService.getAllData("get_project_info").then(res => {
      root.projectList = res.data;
    });

    commonService.getAllData("get_voucher_economic_info").then(res => {
      root.economicList = res.data;
    });
    commonService.getAllData("proc_suppliers").then(res => {
      root.supplierList = res.data;
    });
    commonService.getAllData("proc_packages").then(res => {
      root.packageList = res.data;
    });
    commonService.getAllData("get_credit_list").then(res => {
      root.creditId = res.data;
    });

  },

  methods: {
    // Set Details Cilumn as Currancy
    setColumn(val){
      if(val == 'USD'){
        this.isBdtCol = true;
        this.isUsdCol = false;
      }else{
        this.isBdtCol = false;
        this.isUsdCol = true;
      }
    },
    //Set TR Credit amount
    setTRC(e, key){
        this.formSchema.details[key].transaction_credit = 0
        
            if(this.formSchema.currency_code == "BDT"){
              this.formSchema.details[key].bdt_debit = e
            this.formSchema.details[key].bdt_credit = 0

            }else{
              let bdt_debit = e * this.formSchema.usd_rate
            this.formSchema.details[key].bdt_debit = bdt_debit.toFixed(2)
            this.formSchema.details[key].bdt_credit = 0
            }
       
            if(this.formSchema.currency_code == "USD"){
              this.formSchema.details[key].usd_debit = e
              this.formSchema.details[key].usd_credit = 0

            }else{
                   let usd_debit = e / this.formSchema.usd_rate
                    this.formSchema.details[key].usd_debit = usd_debit.toFixed(2)
                    this.formSchema.details[key].usd_credit = 0
            }
        
      this.checkDrCr();
    },
    //Set TR Debit amount
    setTRD(e, key){
        this.formSchema.details[key].transaction_debit = 0
        if(this.formSchema.currency_code == "BDT"){
          this.formSchema.details[key].bdt_credit = e
          this.formSchema.details[key].bdt_debit = 0

        }else{
           let bdt_credit = e * this.formSchema.usd_rate
           this.formSchema.details[key].bdt_credit = bdt_credit.toFixed(2)
          this.formSchema.details[key].bdt_debit = 0
        }

        if(this.formSchema.currency_code == "USD"){
          this.formSchema.details[key].usd_debit = 0
          this.formSchema.details[key].usd_credit = e

        }else{
              let usd_debit = e / this.formSchema.usd_rate
              this.formSchema.details[key].usd_debit = 0
              this.formSchema.details[key].usd_credit = usd_debit.toFixed(2)
        }
        this.checkDrCr();
    },
    /*
     *Calculate and Check Debit Credit Equality.
     * @return boolean
     */ 
    checkDrCr(){
       
       let formDetails = this.formSchema.details
       let creditAmount = 0
       let debitAmount = 0
       formDetails.forEach((c, i, f)=>{
         creditAmount = parseFloat(creditAmount) + parseFloat(c.transaction_credit)
         debitAmount = parseFloat(debitAmount) + parseFloat(c.transaction_debit)
       })
       const approxeq = (v1, v2, epsilon = 0.001) => Math.abs(v1 - v2) <= epsilon;
       if((creditAmount > 0 && debitAmount > 0) && approxeq((creditAmount),(debitAmount))){
          this.isSubmit = true
          this.isPosting = true
       }else{
          this.formSchema.is_post = "" 
          this.isSubmit = false
          this.isPosting = false
       }
    },
    // Back to list page function
    backtolist() {
      //Voucher List Management
      this.$router.push("/administration/voucher");
    },
    // Voucher Details row added
    addDetails() {
      this.formSchema.details.push({
        eco_head_id: "",
        eco_code: "",
        transaction_debit: "",
        transaction_credit: "",
        bdt_debit: "",
        bdt_credit: "",
        usd_debit: "",
        usd_credit: "",
        fund_source: "",
        client_id:"",
        package_id:"",
        credit_id:"",
        hintAmount:0
      });
    },
    // Voucher Details row deleted
    deleteDetails(index) {
      this.formSchema.details.splice(index, 1);
    },
    // Voucher form submitted
    validateBeforeSubmit(e) {
      let root = this;
      this.Loader = true;
      let formSchema = this.formSchema;
      formSchema.voucher_date = root.changeFormateYMD(
        this.formSchema.voucher_date
      );
      formSchema.module_type = 'administration';
      //if (root.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "voucher_master")
            .then(res => {
              if(res.status == 1)
              {
              this.close(res);
              }else{
                this.SnackbarVal.color = "error";
                this.SnackbarVal.message = res.message;
                this.SnackbarVal.snackbar = true;
              }
            });
        } else {
          //console.log(formSchema.asset_status);
          if (root.$refs.form.validate()) {
            commonService
              .insertFormData(this.formSchema, "voucher_master")
              .then(res => {
                if(res.status == 1)
                {
                this.close(res);
                }else{
                  this.SnackbarVal.color = "error";
                  this.SnackbarVal.message = res.message;
                  this.SnackbarVal.snackbar = true;
                }
              });
          }
        }
      //}
    },
    // onchange economic code name selected
    setName(obj) {
      //alert(index);
      var eco_id = this.formSchema.details[obj].eco_head_id;
      var index = this.economicList
        .map(function(e) {
          return e.id;
        })
        .indexOf(eco_id);
      var economic_code = this.economicList[index].eco_account_code;
      this.formSchema.details[obj].eco_code = economic_code;
      if(eco_id == 39){  this.formSchema.details[obj].fund_source = "IDA"; }
      // Item Amount Validation
      var date = this.changeFormateYMD( this.formSchema.voucher_date);
      var source = this.formSchema.details[obj].fund_source;
      var currency = this.formSchema.currency_code;
      var rate = this.formSchema.usd_rate;
      let arrData = {date:date,source:source,id:eco_id,currency:currency,rate:rate};
      commonService.dataByMulParameters(arrData, "get_amount_by_eco").then(res => {
          this.formSchema.details[obj].hintAmount = res.amount;
      });
    },

    // Set Date Value
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },
    // Close function from here
    close(res) {
      let $this = this;
      this.SnackbarVal.color = "success";
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
      this.Loader = false;
      if (!this.formSchema.id > 0) {
        setTimeout(function () { this.$router.go() }.bind(this), 3000);
      }
    }
  }
};
</script>

<style scoped>
#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td, #customers th {
  border: 2px solid #ddd;
  padding: 8px;
  text-align: left;
  width:1%;
  white-space:nowrap;
}

#customers tr:nth-child(even){background-color: #f2f2f2;}

#customers tr:hover {background-color: #ddd;}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: rgb(89, 90, 89);
  color: white;
}
#auto{
   overflow-x: auto;
   width: 100%;
}
.anim{
  width: 150px;
}
.numFont{
  font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// src/components/procurement/voucher/admin_voucher_form.vue